import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEqual } from 'lodash';

import log from "Utils/logger";

import CONFIG from "Config";

import * as AuthenticationActions from 'Flux/authentication/actions';

const useUpdateContactDetails = () => {
  
  console.log ('*** ** useUpdateContactDetails: hook triggered');
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  
  const isUpdatingContactDetailsRef = useRef(false);
  const hasUpdatedContactDetailsRef = useRef(false);
  const dispatch = useDispatch();

  const storedShopperProfile = useSelector(state => state.authentication.user);
  const storedShopperIdentity = useSelector(state => state.authentication.identity);
  //const storedShopperCollaboratingCauses = 
  //const storedShopperpartner =

  useEffect(() => {
    if (!error) return;
    setTimeout(() => {
      setError(false);
      setMessage('');
    }, 3000);
  } , [error]);
  
 
  const updateContactDetails = async ( contactDetails )  => {
    isUpdatingContactDetailsRef.current = true;
    console.log('7.0 *** ** updateContactDetails: about to commence updateContactDetails: ', contactDetails);
    try {

      const result = await dispatch(AuthenticationActions.updateContactDetails(contactDetails));
      
      console.log ('7.1 *** ** updateContactDetails result: ', result);

      const newShopperProfile = result.data.user;
      const newShopperIdentity = result.data.identity;

      if (!isEqual(storedShopperProfile, newShopperProfile)) {
        console.log('*** * updateContactDetails: shopperProfiles are different');
        console.log('*** * updateContactDetails: storedShopperProfile: ', storedShopperProfile);
        console.log('*** * updateContactDetails: newShopperIdentity: ', newShopperProfile);
        dispatch(AuthenticationActions.setUserProfile(newShopperProfile));
      }
      //adding identity to the profile. Doing it this way as do not want to include partner response


      if (!isEqual(storedShopperIdentity, newShopperIdentity)){
        console.log('*** * updateContactDetails: Identities are different');
        console.log('*** * updateContactDetails: storedShopperIdentity: ', storedShopperIdentity);
        console.log('*** * updateContactDetails: newShopperIdentity: ', newShopperIdentity);
        //const updatedShopperProfile = {...newShopperProfile, identity: storedShopperIdentity};
        //console.log('*** * fetchShopperProfile: updatedShopperProfile: ', updatedShopperProfile);
        dispatch(AuthenticationActions.setUserIdentity(newShopperIdentity));
      }

     
      // if (result?.data?.user) {
      //   console.log ('7.2 *** ** updateContactDetails result.data: ', result.data);
      //   dispatch(AuthenticationActions.setUser( result.data ));
      // } else if (result?.status === false) {
      //   console.log ('7.3 *** ** updateContactDetails false result: ', result);
        
      // }
      
    } catch (exception) {
      console.log(exception);
      log({
        event: "System-Error",
        source: "updateContactDetails",
        info: exception,
        ...exception,
      });
      setError(true);
      setMessage('Oops! Something went wrong');
    } finally {
      console.log('7.4 *** ** updateContactDetails: about to finish SET FALSE isUpdatingContactDetailsRef.current: ', isUpdatingContactDetailsRef.current);
      isUpdatingContactDetailsRef.current = false;
      hasUpdatedContactDetailsRef.current = true;
      //setIsUpdatingContactDetails(false);
    }
  };

  return { updateContactDetails, message, error, isUpdatingContactDetailsRef };
};

export default useUpdateContactDetails;
